// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Ja9Z86Zd","content":"ZlqhqGAg","text":"voDnbUdO","image":"dZP0bNJo"};